import Vue from 'vue'
import VueRouter from 'vue-router'
import { clearSession, hasPermission, isValidAdminToken } from '@/utils/auth/session'

Vue.use(VueRouter)

function isLoggedIn() {
  return isValidAdminToken()
}

export function firstPermittedPath() {
  const menu = [
    { code: 'dashboard', path: '/desktop/dashboard' },
    { code: 'users', path: '/desktop/usermanage' },
    { code: 'paintings', path: '/desktop/paintingmanage' },
    { code: 'photos', path: '/desktop/photomanage' },
    { code: 'documents', path: '/desktop/documentmanage' },
    { code: 'messages', path: '/desktop/messagemanage' }
  ]
  const first = menu.find(item => hasPermission(item.code))
  return first ? first.path : ''
}

export function safeRedirect(value) {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || value.includes('\\')) return ''
  if (value === '/login' || value.startsWith('/login?')) return ''
  return value
}

const routes = [
  { path: '/', redirect: () => (isLoggedIn() ? firstPermittedPath() || '/login' : '/login') },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/LoginView.vue'),
    meta: { guest: true }
  },
  {
    path: '/desktop',
    component: () => import('@/views/DesktopView.vue'),
    meta: { requiresAuth: true },
    children: [
      { path: '', redirect: () => firstPermittedPath() || '/login' },
      {
        path: 'documentmanage',
        component: () => import('@/views/DocumentManage.vue'),
        meta: { permission: 'documents' }
      },
      {
        path: 'dashboard',
        component: () => import('@/views/DashboardView.vue'),
        meta: { permission: 'dashboard' }
      },
      {
        path: 'usermanage',
        component: () => import('@/views/UserManage.vue'),
        meta: { permission: 'users' }
      },
      {
        path: 'paintingmanage',
        component: () => import('@/views/MediaManage.vue'),
        props: { kind: 'painting', title: '绘画管理' },
        meta: { permission: 'paintings' }
      },
      {
        path: 'photomanage',
        component: () => import('@/views/MediaManage.vue'),
        props: { kind: 'photo', title: '相片管理' },
        meta: { permission: 'photos' }
      },
      {
        path: 'messagemanage',
        component: () => import('@/views/MessageManage.vue'),
        meta: { permission: 'messages' }
      }
    ]
  },
  { path: '*', redirect: '/' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const logged = isLoggedIn()
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  const permissionRecord = to.matched.find(record => record.meta.permission)
  const requiredPermission = permissionRecord && permissionRecord.meta.permission
  if (!logged && localStorage.getItem('token')) clearSession()
  if (requiresAuth && !logged) {
    next({ path: '/login', query: { redirect: safeRedirect(to.fullPath) } })
  } else if (to.meta.guest && logged) {
    const first = firstPermittedPath()
    if (first) next(first)
    else {
      clearSession()
      next()
    }
  } else if (requiredPermission && !hasPermission(requiredPermission)) {
    const fallback = firstPermittedPath()
    fallback && fallback !== to.fullPath ? next(fallback) : next(false)
  } else {
    next()
  }
})

export default router
